import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Region} from '../../../../models/region';
import {NgForOf, NgIf} from '@angular/common';
import {Subject, takeUntil} from 'rxjs';
import {User} from '../../../../models/user';
import {Neighborhood} from '../../../../models/neighborhood';
import {CONTENT} from './room-list-detail-content';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {AuthService} from '../../../../services/auth.service';
import {GeneralService} from '../../../../services/general.service';
import {FilterService} from '../../../../services/filter.service';
import {SeoService} from '../../../../services/seo.service';
import {Place} from '../../../../models/place';

@Component({
  selector: 'app-room-list-detail',
  imports: [
    NgForOf,
    NgIf,
    RouterLink
  ],
  templateUrl: './room-list-detail.component.html',
  styleUrl: './room-list-detail.component.scss'
})
export class RoomListDetailComponent implements OnInit, OnDestroy {
  onDestroy$ = new Subject<boolean>();

  @Input() region!: Region
  @Input() place: Place | null = null

  currentUser: User | null = null;

  // Region
  regionSlug: string | null = null;

  // Neighborhood
  neighborhoodSlug: string | null = null
  neighborhood: Neighborhood | null = null;
  neighborhoods: Neighborhood[] = [];

  // Place
  placeSlug: string | null = null

  content: any = CONTENT;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private generalService: GeneralService,
    private filterService: FilterService,
    private seoService: SeoService) {
  }

  ngOnInit() {
    this.authService.currentUser$.pipe(takeUntil(this.onDestroy$)).subscribe(currentUser => {
      if (currentUser) this.currentUser = currentUser;
    });

    this.route.params.pipe(takeUntil(this.onDestroy$)).subscribe(params => {
      this.regionSlug = params['regionSlug'];
      this.neighborhoodSlug = params['neighborhoodSlug'];
      this.placeSlug = params['placeSlug'];

      this.refreshContent()
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  refreshContent() {
    this.neighborhoods = this.filterService.neighborhoods$.value

    // Sort the neighborhood by the amount of places
    this.neighborhoods = this.neighborhoods.sort((a, b) => b.count - a.count);

    // Set the current neighborhood if it exists in the neighborhoods
    if (this.regionSlug && this.neighborhoodSlug) {
      const matchingNeighborhoods = this.neighborhoods.filter(neighborhood => {
        return neighborhood._id === this.generalService.kebabCase(this.regionSlug + ' ' + this.neighborhoodSlug);
      });
      this.neighborhood = matchingNeighborhoods.length > 0 ? matchingNeighborhoods[0] : null;
    }

    // Place
    if (this.region && this.neighborhood && this.place) {
      this.seoService.setTitle(`Croissant | Book Conference Rooms in ${this.place.name} | ${this.neighborhood.name}, ${this.region.name}`)
      this.seoService.setDescription(`Find conference rooms at ${this.place.name} in ${this.neighborhood.name}, ${this.region.name}. Instantly book a conference room with Croissant.`)
      return;
    }

    // Neighborhood
    if (this.region && this.neighborhood) {
      this.seoService.setTitle(`Croissant | Book Conference Rooms in ${this.neighborhood.name} | ${this.region.name}`)
      this.seoService.setDescription(`Find conference rooms in ${this.neighborhood.name}, ${this.region.name}. Instantly book a conference room with Croissant.`)
      return;
    }

    // Region
    if (this.region) {
      this.seoService.setTitle(`Croissant | Book Conference Rooms in ${this.region.name}`)
      this.seoService.setDescription(`Find conference rooms in ${this.region.name}. Instantly book a conference room with Croissant.`)
      return;
    }

    return;
  }
}
